import React from 'react';
import { Outlet } from 'react-router-dom';
import Menu from 'components/menu';
import FOOTER from 'components/footer';
import AvisoPopup from 'components/avisos';

const MainLayout = () => {
    return (
        <>
            <Menu />
            <div className="mt-page">
                <Outlet />
            </div>
            <FOOTER />
            <AvisoPopup />
        </>
    );
};

export default MainLayout;
